import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import btnGroup from './template/buttonGroup.vue';
import Vue from 'vue';
import Base from './base';
var defaultOptions = {
  renderTo: void 0,
  padding: void 0,
  margin: void 0
};

var BtnGroup = /*#__PURE__*/function (_Base) {
  _inherits(BtnGroup, _Base);

  var _super = _createSuper(BtnGroup);

  function BtnGroup(param) {
    var _this2;

    _classCallCheck(this, BtnGroup);

    _this2 = _super.call(this);

    _this2.initialize(param, defaultOptions).init();

    return _this2;
  }

  _createClass(BtnGroup, [{
    key: "createModel",
    value: function createModel() {
      var h = this.$createElement;

      var _this = this;

      var mountDom = document.createElement('div');
      this.options.renderTo.appendChild(mountDom);
      return new Vue({
        el: mountDom,
        components: {
          btnGroup: btnGroup
        },
        render: function render() {
          var h = arguments[0];
          return h("btn-group", {
            "attrs": {
              "options": _this.options,
              "window": _this.$window
            }
          });
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.model = this.createModel();
    }
  }]);

  return BtnGroup;
}(Base);

export { BtnGroup as default };